$('.pnr_buy').click(function(){
    window.open('https://store.oxva.com/products/oxva-origin-2-kit');
})
$('.pnr_cart').click(function(){
    var element = document.querySelector(".origin2_section10");
    element.scrollIntoView({block: "end"});
})
$('.pnr_spec').click(function(){
    var element = document.querySelector(".origin2_section12");
    element.scrollIntoView({block: "end"});
})

window.onload=function(){
    if(window.width > 768){
  var controller = new ScrollMagic.Controller();
  var pinIntroScene = new ScrollMagic.Scene({
      triggerElement: "#origin2_section1",
      triggerHook: 0,
      duration: '99%'
  })
  .setPin("#origin2_section1", {pushFollowers: false})
  .addTo(controller);
  var pinIntroScene2 = new ScrollMagic.Scene({
      triggerElement: "#origin2_section2",
      triggerHook: 0,
      duration: '100%'
  })
  .setPin("#origin2_section2", {pushFollowers: true})
  .addTo(controller);


    }
}

//section4
new Glide('#glide1',{
    gap: 0
}).mount();

//section13
const allIcons = document.querySelectorAll('.origin2_section13 .glide__bullet');


    // event listeners
    allIcons.forEach(el =>{
        el.addEventListener('mouseenter', ()=>{
            el.closest(".glide__bullet").click();
        });
    })


    new Glide('#glide2',{
        gap: 0
    }).mount();